<template>
    <div class="drawElectronicFence bd">
        <!-- 搜索 -->
        <div class="search-box">
            <el-input v-model="keyword" placeholder="请输入关键字"></el-input>
            <button @click="handleSave">
                确定
            </button>
        </div>
        <!-- 地图 -->
        <baidu-map class="baidu-map" :zoom="zoom" :center="mapCenter" @ready="handleReady" @click="clickMap">
            <bm-local-search class="search-panel" :keyword="keyword" :auto-viewport="true" :panel="true" @infohtmlset="onSearchResult"></bm-local-search>
            <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" panel show-address-bar></bm-geolocation>
            <bm-marker v-show="showMarker" :position="location.point">
                <bm-info-window :show="showMarker">
                    {{ location.address }}
                </bm-info-window>
            </bm-marker>
        </baidu-map>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import BaiduMap from 'vue-baidu-map-v3'
Vue.use(BaiduMap, {
    ak: '7FR14186sYk3MqjP9ggWxuHx1AQkRzZX'
})
import currencyFun from '@/assets/js/currencyFun';
export default {
    props: {
        extr: {
            type: Object,
        },
    },
    data() {
        return {
            loading: false,
            keyword: '',
            zoom: 12,
            mapCenter: { lng: 117.120098, lat: 34.6512 },
            mouseTool: {},
            marker: {},
            // 定位信息
            location: {
                point: {},
                address: '',
            },
            showMarker: false,
            searchOption: {
                city: '全国',
                citylimit: true
            },
            // 百度地图对象
            BMap: null,
            mapObj: {}, // 地图对象
            onlyPoint: false,

        };
    },
    mounted () {
        if (this.extr.onlyPoint) {
            this.onlyPoint = this.extr.onlyPoint;
        }
    },
    computed: {},
    methods: {
        // 地图
        handleReady({ BMap, map }) {
            this.BMap = BMap;
            this.mapObj = map;
            // 开启鼠标滚动缩放地图
            map.enableScrollWheelZoom(true);
            this.initMap();
        },
        // 确定
        handleSave() {
            if (this.location.address) {
                const res = [this.location.point.lng,this.location.point.lat];
                this.extr.sureCallback(res,this.location.address);
                window.hideToast();
            } else {
                this.$message.warning('请绘制坐标点！');
            }
        },
        // 取消
        handleClose() {
            window.hideToast();
        },

        // 绘制
        draw() {
            const polygon = new AMap.Polygon({
              fillColor:'#00b0ff',
              strokeColor:'#80d8ff',
              path: [],
              //同Polygon的Option设置
            });
            return polygon;
        },
        // 搜索打点
        onSearchResult(result) {
            this.location = {
                point: result.point,
                address: result.address,
            }
            this.mapCenter = result.point;
        },
        // 点击地图 打点
        clickMap ({point}) {
            this.showMarker = false;
            let geocoder = new this.BMap.Geocoder();
            geocoder.getLocation(point,(result)=>{
                if(result) {
                    this.location = {
                        point: result.point,
                        address: result.address,
                    }
                    this.showMarker = true;
                }
            });
        },
        // 初始化地图数据
        initMap () {
            this.loading = true;
            this.$nextTick(()=>{
                if (this.extr.position[0]&&this.extr.position[1]) {
                    const point = {lng: this.extr.position[0],lat: this.extr.position[1]}
                    this.location = {
                        point: point,
                        address: this.extr.address,
                    }
                    this.mapCenter = point;
                    this.showMarker = true;
                    this.loading = false;
                } else {
                    this.BMapGetPosition();
                }
            });
        },
        /**
         * 获取百度定位
         * 高德地图获取定位报错
         */
        async BMapGetPosition () {
            const BMapGeolocation = new this.BMap.Geolocation();
            BMapGeolocation.getCurrentPosition((r) => {
                const point = {lng: r.longitude,lat: r.latitude}
                this.clickMap({point});
                this.mapCenter = point;
                this.zoom = 12;
                this.$forceUpdate();
                this.loading = false;
            });
        },
    },
};
</script>
<style lang="stylus">
.drawElectronicFence
    height 100%
    overflow hidden
    position relative
    .search-box
        padding-right 20px
        width 100%
        display flex
        align-items center
        position absolute
        left 9px
        top 10px
        z-index 99
        .el-input
            .el-input__inner
                height: 36px
        button
            width: 80px
            height: 36px
            margin-left 20px
            background: #1577d2;
            color: #fff;
            font-size: 16px
            border: none;
            border-radius: 2px
    .baidu-map
        width 100%
        height 100%
        .search-panel
            position absolute
            top 50px
            left 10px
            height calc(100% - 50px)
            overflow-y auto
        .map
            width 100%
            height 100%
            z-index 1
        .bm-local-search
            z-index 99
        .amap-box
            height calc(100% - 70px)
        .handle-btn
            padding-top 20px
            text-align center
        .handle-types
            position absolute
            bottom 10px
            right 10px
            background #fff
            padding 10px
            .el-button
                padding 0 20px
            .active
                background #409EFF
                border-color #409EFF
                color #fff
        .amap-logo
            display none
            opacity 0 !important
        .amap-copyright
            opacity 0
</style>
